import React from "react";
import Layout from "../layout/layout";
import Profiletabs from "./Profiletabs";
import { Link } from "react-router-dom";

const Secuirty = () => {
  return (
    <Layout>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title">
              <div className="row align-items-center justify-content-between">
                <div className="col-xl-4">
                  <div className="page-title-content">
                    <h3>Security</h3>
                    <p className="mb-2">Welcome Ekash Finance Management</p>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="breadcrumbs">
                    <Link to="#">Home </Link>
                    <span>
                      <i className="fi fi-rr-angle-small-right" />
                    </span>
                    <Link to="#">Security</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12">
            <Profiletabs />
            <div className="row">
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Social Security Card</h4>
                  </div>
                  <div className="card-body">
                    <div className="id-card-img">
                      <img src="images/id.png" alt="" className="img-fluid" />
                    </div>
                    <div className="id-info mt-3">
                      <h4>Carla Pascle </h4>
                      <ul>
                        <li className="verified mb-0">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-br-id-badge" />
                            </span>
                            <div>
                              <h5>0024 5687 2254 3698</h5>
                              <p>
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <Link
                        to="/id-front-and-back-upload"
                        className="btn btn-primary mt-3"
                      >
                        Add New ID
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Email Verification</h4>
                  </div>
                  <div className="card-body">
                    <div className="email-verification">
                      <ul>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-envelope" />
                            </span>
                            <div>
                              <h5> hello@example.com</h5>
                              <p>
                                {" "}
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-envelope" />
                            </span>
                            <div>
                              <h5> hello@example.com</h5>
                              <p>
                                {" "}
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-envelope" />
                            </span>
                            <div>
                              <h5> hello@example.com</h5>
                              <p>
                                {" "}
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="pending">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-envelope" />
                            </span>
                            <div>
                              <h5> hello@example.com</h5>
                              <p className="text-danger">
                                <span className="text-danger">
                                  <i className="fi fi-rs-circle-xmark" />
                                </span>
                                Verification pending
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <form action="https://ekash.vercel.app/verify-email.html">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="hello@example.com "
                      />
                      <button className="btn btn-primary mt-3">
                        Add New Email
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Phone Verification</h4>
                  </div>
                  <div className="card-body">
                    <div className="phone-verification">
                      <ul>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-phone-call" />
                            </span>
                            <div>
                              <h5> +1 135 468 45 </h5>
                              <p>
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-phone-call" />
                            </span>
                            <div>
                              <h5> +1 135 468 45 </h5>
                              <p>
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="verified">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-phone-call" />
                            </span>
                            <div>
                              <h5> +1 135 468 45 </h5>
                              <p>
                                <span>
                                  <i className="fi fi-sr-badge-check" />
                                </span>
                                Verified
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="pending">
                          <div className="d-flex">
                            <span className="round-icon">
                              <i className="fi fi-rr-phone-call" />
                            </span>
                            <div>
                              <h5> +1 135 468 45</h5>
                              <p className="text-danger">
                                <span className="text-danger">
                                  <i className="fi fi-rs-circle-xmark" />
                                </span>
                                Verification pending
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    
                      <input
                        type="text"
                        className="form-control"
                        placeholder="+1 135 468 45 "
                      />
                      <Link to={'/verification'} className="btn btn-primary mt-3">
                        Add New Phone
                      </Link>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Secuirty;
